import { CurrenciesState, Currency } from '@modules-deprecated/app/currencies/types'

import { EQUIVALENT_EXCHANGE_RATE } from '../constants'

const DEFAULT_CURRENCY_ID = 'DKK'

interface CalculateExchangeRateUsingDKKRatesOptions {
  currencyStates?: CurrenciesState
  sourceCurrencyId: string
  targetCurrencyId: string
}

export const calculateExchangeRateUsingDKKRates = ({
  currencyStates,
  sourceCurrencyId,
  targetCurrencyId,
}: CalculateExchangeRateUsingDKKRatesOptions): number => {
  const sourceCurrency = currencyStates?.currencies?.find((currency: Currency) => currency.id === sourceCurrencyId)
  if (targetCurrencyId === DEFAULT_CURRENCY_ID) {
    return sourceCurrency?.exchangeRate || EQUIVALENT_EXCHANGE_RATE
  }

  const targetCurrency = currencyStates?.currencies?.find((currency: Currency) => currency.id === targetCurrencyId)

  return sourceCurrency && targetCurrency
    ? sourceCurrency.exchangeRate / targetCurrency.exchangeRate
    : EQUIVALENT_EXCHANGE_RATE
}
